import { Box, Menu, Text } from '@zillow/constellation-10';
import { IconUserFilled } from '@zillow/constellation-icons';

import type { Application } from '../../../../models/Types';
import { FULLSTORY_EXCLUDE } from '../../../../constants/analytics';

type Props = {
  applicationList: Array<Application>;
  onAddApplicants: (application: Application) => void;
  disabled: boolean;
};

function ApplicantSelector({ applicationList, onAddApplicants, disabled }: Props) {
  function renderMenuText(applicants): string {
    const textArray = [];
    applicants.forEach((applicant) => {
      textArray.push(`${applicant.firstName} ${applicant.lastName}`);
    });
    return textArray.join(', ');
  }

  return (
    <>
      <Menu
        trigger={
          <Menu.Button disabled={disabled} data-test="select-a-tenant-dropdown-btn">
            Select tenants
          </Menu.Button>
        }
        content={
          <Box css={{ maxHeight: '200px', overflowY: 'auto' }}>
            <Menu.Heading level={6}>You can only select applicants who have completed their applications.</Menu.Heading>
            {applicationList.map((application: Application, index: number) => {
              const { applicants } = application;

              return (
                <Menu.Item onClick={() => onAddApplicants(application)} key={index} className={FULLSTORY_EXCLUDE}>
                  <Menu.ItemIcon render={<IconUserFilled />} />
                  <Menu.ItemLabel>
                    <Box css={{ display: 'flex', flexDirection: 'column' }}>{renderMenuText(applicants)}</Box>
                  </Menu.ItemLabel>
                </Menu.Item>
              );
            })}
          </Box>
        }
      />
      <Text
        css={{
          marginLeft: 'layout.tight',
          marginRight: 'layout.tight',
          marginTop: { base: 'layout.tighter', lg: 0 },
          marginBottom: { base: 'layout.tighter', lg: 0 },
        }}
      >
        or
      </Text>
    </>
  );
}

export default ApplicantSelector;
